import { ColumnDef, Row } from "@tanstack/react-table";

import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import GeneralLedgerTable from "../Reusable/GeneralLedgerTable";
import Filter from "./PartyFilter";
import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import Button from "../Reusable/Button";

const columns: ColumnDef<any, any>[] = [
  {
    accessorKey: "voucher_date",
    header: "Date",
    cell: ({ getValue }: any) => {
      return (
        <p className={tw`whitespace-nowrap`}>
          {getValue() ? moment(getValue()).format("YY-MM-DD") : ""}
        </p>
      );
    },
  },
  {
    accessorKey: "miti",
    header: "Miti",
    cell: ({ getValue }: any) => {
      return <p className={tw`whitespace-nowrap`}>{getValue()}</p>;
    },
  },
  {
    accessorKey: "particular",
    header: "Particulars",
  },
  {
    accessorKey: "debit",
    header: "Dr. Amount",
    cell: ({ getValue }: any) => {
      return (
        <p>
          {" "}
          {Number(getValue()).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? 0}
        </p>
      );
    },
  },
  {
    accessorKey: "credit",
    header: "Cr. Amount",
    cell: ({ getValue }: any) => {
      return (
        <p>
          {" "}
          {Number(getValue()).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) ?? 0}
        </p>
      );
    },
  },
  {
    accessorKey: "balance",
    header: "Balance",
    cell: ({ getValue }: any) => {
      return (
        <p>
          {Math.abs(getValue()).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {getValue() < 0 ? "DR" : "CR"}
        </p>
      );
    },
  },
  {
    accessorKey: "narration",
    header: "Narration",
  },
];

export default () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || [],
      user: searchParams.get("user") || "",
      created: searchParams.get("created") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });

  const navigateMap: Record<string, string> = {
    "Purchase Invoice": "/accounting/purchase/edit/",
    "Purchase Return": "/accounting/purchase-return/edit/",
    "Sales Invoice": "/accounting/sales/edit/",
    "Sales Return": "/accounting/sales-return/edit/",
    "Bank Payment": "/accounting/bank-payment/edit/",
    "Bank Receipt": "/accounting/bank-receipt/edit/",
    "Cash Receipt": "/accounting/cash-receipt/edit/",
    "Cash Payment": "/accounting/cash-payment/edit/",
    "Credit Note": "/accounting/credit-note/edit/",
    "Debit Note": "/accounting/debit-note/edit/",
    "Journal Voucher": "/accounting/journal-voucher/edit/",
  };

  const handleNavigate = (row: Row<any>) => {
    const basePath = navigateMap[row?.original?.bill?.type];
    if (basePath) {
      navigate(`${basePath}${row?.original?.bill?.id}`);
    }
  };
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={tw`space-y-2`}>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <GeneralLedgerTable
        customSearch={true}
        columns={columns}
        handleRowClick={handleNavigate}
        queryKey="general-ledger-party"
        url={`${APIS.GENERAL_LEDGER}party-wise/`}
        params={{
          ...formValues,
          party__in: formValues?.party__in
            ?.map((item) => item?.value)
            .join(","),
        }}
      />
    </div>
  );
};

